<template>
  <div class="baike-entry">
    <strong v-if="$global.tab.title === 'auto_index'">
        <a :href="knowledge.url" target="_blank" @click="countAd(4187)"><em>{{knowledge.title}}</em>的百科词条</a>
    </strong>
    <div class="bk-box">
      <div class="bk-top">
        <a :href="knowledge.url" target="_blank" class="bk-pic" @click="pictureBp">
            <img width="135" height="90" :alt="knowledge.title" :src="knowledge.photo || $baikeHeadDefaultImgUrl" />
        </a>
        <div class="bk-info">
          <p class="bk-tit">
            <a :href="knowledge.url" target="_blank" @click="titleBp">{{knowledge.title}}</a>
          </p>
          <p class="bk-des">
            {{bkDes}}
            <a :href="knowledge.url" target="_blank" class="blue" @click="detailsBp">详情&gt;&gt;</a>
          </p>
        </div>
      </div>
      <div class="bk-bottom">
        <div class="bk-item bk-about">
          <span>相关标签：</span>
          <ul>
            <li v-for="(tag,index) in knowledge.tags" :key="index">
              <a :href="tag.tag_url" target="_blank" @click="tagsBp">{{tag.tag_name}}</a>
            </li>
          </ul>
        </div>
        <div class="bk-node-item bk-node" v-if="knowledge.items">
          <span>词条节点：</span>
          <ul :class="{'control-h' : upDown }">
            <li v-for="(item,index) in knowledge.items" :key="index">
              <a :href="item.item_url" target="_blank" :title="item.item_name" @click="nodeBp">{{item.item_name}}</a>
            </li>
			<a class="bk-more blue" v-if="knowledge.items && knowledge.items.length > 5" :class="[upDown?'up':'down']" href="javascript:;" @click="upDown=!upDown">{{upDown?'收起':'更多'}}</a>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'Baike',
    props: {
        knowledge: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            upDown: false, //便签词展开或者收取
        }
    },
    methods: {
        //模块标题埋点 bp-埋点
        pictureBp() {
            if(this.$global.tab.title === 'auto_index') {
                //综合页
                this.countAd(4188)
            }else {
                //百科页
                this.countAd(4446)
            }
        },
        titleBp() {
            if(this.$global.tab.title === 'auto_index') {
                //综合页
                this.countAd(4189)
            }else {
                //百科页
                this.countAd(4447)
            }
        },
        detailsBp() {
            if(this.$global.tab.title === 'auto_index') {
                //综合页
                this.countAd(4190)
            }else {
                //百科页
                this.countAd(4448)
            }
        },
        tagsBp() {
            if(this.$global.tab.title === 'auto_index') {
                //综合页
                this.countAd(4191)
            }else {
                //百科页
                this.countAd(4449)
            }
        },
        //节点
        nodeBp() {
            if(this.$global.tab.title === 'auto_index') {
                //综合页
                this.countAd(4192)
            }else {
                //百科页
                this.countAd(4450)
            }
        },
    },
    computed: {
        bkDes() {
            if(this.knowledge.content) {
                if(this.knowledge.content && this.knowledge.content.length > 70) {
                    return this.knowledge.content.substring(0,70) +'...'
                }else {
                    return this.knowledge.content
                }
            }else {
                return ''
            }
        }
    },
};
</script>

<style lang="scss" scoped>
.baike-entry {
    margin-top: 25px;
    font-size: 12px;
    strong {
        font-weight: normal;
        font-size: 16px;
        line-height: 32px;
        a {
            text-decoration: underline;
            color: #225599;
            em {
                color: #cc0000;
                text-decoration: underline;
                font-style: normal;
            }
        }
    }
    .bk-box {
        border: 1px solid #d7d7d7;
        .bk-top {
            border-bottom: 1px solid #e3e3e3;
            padding: 1px;
            height: 90px;
            overflow: hidden;
            display: flex;
        }
        .bk-info {
            overflow: hidden;
            *zoom: 1;
            padding-left: 20px;
            overflow: hidden;
            .bk-tit {
                display: block;
                line-height: 30px;
                margin-top: 4px;
                font-weight: bold;
                font-size: 14px;
                a {
                    color: #225599;
                    &:hover {
                        text-decoration: underline;
                    }
                }
            }
            .bk-des {
                height: 56px;
                overflow: hidden;
                line-height: 25px;
                .blue {
                    color: #259;
                    &:hover {
                        text-decoration: underline;
                        color: #ff6600;
                    }
                }
            }
        }
        .bk-about {
            padding: 0 10px 10px;
            border-bottom: 1px dashed #f1f1f1;
            display: flex;
            ul {
                display: flex;
                li {
                    height: 27px;
                    margin: 10px 10px 0 0;
                    overflow: hidden;
                }
            }
            
            span {
                margin-top: 12px;
            }
            a {
                height: 25px;
                padding: 0 8px;
                line-height: 25px;
                color: #333333;
                border: 1px solid #e5e5e5;
                float: left;
                overflow: hidden;
                white-space: nowrap;
                &:hover {
                    background: #259;
                    color: #fff !important;
                    border: 1px solid #259;
                    text-decoration: none;
                }
        }
        }
        .bk-node-item {
            overflow: hidden;
            li {
                margin-left: 10px;
                padding-bottom: 10px;
            }
        }
    }
    .bk-node {
        display: flex;
        align-items: flex-start;
        padding-left: 10px;
        padding-top: 10px;
        ul {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            flex: 1;
            overflow: hidden;
            height: 26px;
            position: relative;
            &.control-h {
                height: auto;
            }
            .bk-more {
                position: absolute;
                top: 2px;
                right: 20px;
                width: 35px;
                height: 14px;
                line-height: 14px;
                display: block;
                overflow: hidden;
                z-index: 100;
                &.down {
                    background: url(//www1.pcauto.com.cn/2014/kuaisou/images/bk-hide.png) no-repeat right -5px;
                }
                &.up {
                    background: url(//www1.pcauto.com.cn/2014/kuaisou/images/bk-hide.png) no-repeat right 5px;
                }
            }
        }
        a {
            color: #225599;
                vertical-align: middle;
            &:hover {
                text-decoration: underline;
            }
        }
    }
}
</style>
